import { render, staticRenderFns } from "./NavbarMainItem.vue?vue&type=template&id=48057a56&"
import script from "./NavbarMainItem.vue?vue&type=script&lang=js&"
export * from "./NavbarMainItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports